import { MtGroup, MtProjectGroup, MtUser } from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import {
    PermissionType,
    ProjectPermissionItem,
    ProjectPermissionsSectioned,
} from "client/store/utils"
import { UserFilters, GroupFilters, ProjectGroupFilters } from "client/store"
import * as types from "./types"


export const setProjectPermissions = (projectPermissions: ProjectPermissionsSectioned) => ({
    type: inferLiteral(types.SET_PROJECT_PERMISSIONS),
    projectPermissions,
})

export const updateProjectPermission = (
    section: string,
    permissionId: string,
    type: PermissionType,
    value: ProjectPermissionItem,
) => ({
    type: inferLiteral(types.UPDATE_PROJECT_PERMISSION),
    data: { section, permissionId, type, value },
})

export const toggleProjectPermissionCustomizable = (
    section: string,
    permissionId: string,
) => ({
    type: inferLiteral(types.TOGGLE_PROJECT_PERMISSION_CUSTOMIZABLE),
    section,
    permissionId,
})

// not assigned account groups
export const setProjectPermissionsAccountGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_IDS),
    groupIds,
})
export const setProjectPermissionsAccountGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setProjectPermissionsAccountGroupFilters = (filters: GroupFilters) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_FILTERS),
    filters,
})
export const setProjectPermissionsAccountGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_ACCOUNT_GROUP_SELECTED),
    selected,
})

// not assigned project groups
export const setProjectPermissionsProjectGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_GROUP_IDS),
    groupIds,
})
export const setProjectPermissionsProjectGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setProjectPermissionsProjectGroupFilters = (filters: ProjectGroupFilters) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_GROUP_FILTERS),
    filters,
})
export const setProjectPermissionsProjectGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_GROUP_SELECTED),
    selected,
})

// not assigned project users
export const setProjectPermissionsProjectUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_USER_IDS),
    userIds,
})
export const setProjectPermissionsProjectUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setProjectPermissionsProjectUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_USER_FILTERS),
    filters,
})
export const setProjectPermissionsProjectUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_PROJECT_USER_SELECTED),
    selected,
})

export const setProjectPermissionsReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_PERMISSIONS_RELOAD_LIST),
    value,
})
